import { render, staticRenderFns } from "./ModalImportLayersTreeItemExternal.vue?vue&type=template&id=47958578&scoped=true"
import script from "./ModalImportLayersTreeItemExternal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalImportLayersTreeItemExternal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ModalImportLayersTreeItemExternal.vue?vue&type=style&index=0&id=47958578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47958578",
  null
  
)

export default component.exports